__webpack_require__.p = "/cinemas/";